import React, { useEffect, useRef, useState } from 'react'
import translations from '../../shared/Translations';
import { useNavigate } from 'react-router-dom';
import superAdminApis from '../../api/services/admin-pages/superAdmin';
import { toast } from 'react-toastify';
import logo from '../../assets/images/Asset 12 5.png'
import AOS from "aos";
import "aos/dist/aos.css";
import CommonPagination from '../../components/pagination';
import './index.css'
import { baseURL } from '../../api/api';

function Reports() {

  const navigate = useNavigate();

    useEffect(() => {
      AOS.init({
        duration: 1000,
        once: false,
        mirror: true,
      });
    }, []);

  const [lang, setLang] = useState("en");
  const t = (key) => translations[lang][key] || key;

  useEffect(() => {
    const savedLang = localStorage.getItem("lang");
    if (savedLang) setLang(savedLang);
  }, []);

  const [closedLoans, setClosedLoans] = useState([]);

  const [selectedCustomer, setSelectedCustomer] = useState(null);

  console.log(selectedCustomer);

const [pageSizes, setPageSizes] = useState(["5", "10", "15", "25", "50", "75", "100","125","150","200","250","500","1000"]);


  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);


  // Fetch closed loans
  useEffect(() => {
    handleClosedList(currentPage)
  }, [currentPage]);


  const handleClosedList = (page) => {
    setLoading(true);

    const apiData = {
      pageIndex: page - 1,
      dataLength: recordsPerPage,
    };

    superAdminApis.customerClosedListAPI(apiData)
      .then((responseData) => {
        if (responseData?.apiStatus?.code === "200") {
          setLoading(false);
          setClosedLoans(responseData?.result?.customerDetails || []);
          setTotalRecords(responseData?.result?.totalRecordCount || 0);
        } else {
          setClosedLoans([]);
          setLoading(false);
          // toast.error(responseData?.apiStatus?.message || "Failed to fetch data");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching customer details:", error);
        toast.error("An error occurred while fetching data.");
      });
  };

const totalPages = Math.ceil(totalRecords / recordsPerPage);


  const handleBackCustomer = () => {
    navigate("/dashboard");
  };


const contentRef = useRef(null);
const [btnLoading, setBtnLoading] = useState(false);



const downloadPDF = async () => {
  setBtnLoading(true);

  if (!contentRef.current) return;

  const clone = contentRef.current.cloneNode(true);

  // Wait for images
  const images = clone.querySelectorAll("img");
  await Promise.all(
    Array.from(images).map(
      (img) =>
        new Promise((res) => {
          if (img.complete) res(true);
          else {
            img.onload = () => res(true);
            img.onerror = () => res(true);
          }
        })
    )
  );

  const printWindow = window.open("", "_blank", "width=900,height=700");

  if (!printWindow) {
    alert("Popup blocked");
    setBtnLoading(false);
    return;
  }

  printWindow.document.write(`
    <html>
      <head>
        <title>Customer Loan Report</title>

        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css">

        <style>

          body {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
            background: #f5f7fb;
            font-family: Arial, sans-serif;
          }

          .a4-page {
            background: #fff;
            padding: 30px;
            border-radius: 10px;
          }

          h2 {
            color: #198754;
            font-size:20px;
          }

          h3 {
            text-align: center;
            letter-spacing: 2px;
            color: #0d6efd;
            font-weight: bold;
          }

          h4 {
            color: #6f42c1;
            border-left: 5px solid #198754;
            padding-left: 10px;
            margin-top: 20px;
            font-size:23px;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 10px;
            margin-bottom: 20px;
          }

          td {
            padding: 10px;
            border-bottom: 1px solid #e9ecef;
          }

          tr:nth-child(even) {
            background: #f8f9fa;
          }

          .section-box {
            padding: 15px;
            border-radius: 10px;
            margin-bottom: 20px;
          }

          .customer-box {
            background: #e9f9f1;
          }

          .loan-box {
            background: #f1f3f5;
          }

          table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 6px;
}

td {
  padding: 10px;
  border-bottom: 1px solid #e9ecef;
}

          .watermark {
            position: fixed;
            opacity: 0.08;
            font-size: 45px;
            transform: rotate(-30deg);
            top: 40%;
            left: 20%;
            color: #198754;
          }

          .amount-green { color: #198754; font-weight: bold; }
          .amount-red { color: #dc3545; font-weight: bold; }
          .amount-blue { color: #0d6efd; font-weight: bold; }

        </style>
      </head>

      <body>
        ${clone.outerHTML}

        <script>
          window.onload = function () {
            window.focus();
            window.print();
            window.onafterprint = () => window.close();
          };
        </script>
      </body>
    </html>
  `);

  printWindow.document.close();
  setBtnLoading(false);
};



  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mt-3 mb-4">

        {/* Left side (Breadcrumb) */}
        <nav aria-label="breadcrumb" className={lang === "ta" ? "fs-tamil" : ""}>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <a href="#" onClick={handleBackCustomer}>  {t("dashboard")}</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Customer Closed Loan Reports
            </li>
          </ol>
        </nav>



      </div>

      <div className='customer-list-container card'>
     <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-2 mb-4">
  
  <h5 className={`heading-with-line mb-2 mb-md-0 aquanew-text-effect ${lang === "ta" ? "fs-tamil" : ""}`}>
<i className="bi bi-archive-fill  me-1"  style={{ color: "#121213" }}></i> Closed Loans
    <span className="smooth-line"></span>
  </h5>
  </div>


<div className="table-section mt-3" >
<table data-aos="fade-up">
      <thead>
        <tr>
          <th>Sl No</th>
          <th>Loan ID</th>
          <th>Customer</th>
          <th>Closed Date</th>
      <th className="text-center">Status</th>
      <th className='text-center'>Download</th>
  
        </tr>
      </thead>
    <tbody>
    {loading ? (
      <tr>
        <td colSpan="9" className="text-center">
          <div className="gold-dots-loader">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </td>
      </tr>
    ) : closedLoans?.length === 0 ? (
      <tr>
        <td colSpan="9" className="text-center">No records found</td>
      </tr>
    ) : (
      closedLoans?.map((item, i) => (
        <tr key={i}>
           <td>
          {(currentPage - 1) * recordsPerPage + i + 1}
        </td>
          <td>{item.loan_id}</td>

          <td>{item.name}</td>

          {/* Closed Date → from item.date */}
          
<td>
  {item.last_payment_date 
    ? item.last_payment_date.split(" ")[0].split("-").reverse().join("-")
    : "-"
  }
</td>
          <td className='text-center align-middle'>{item?.paid_status === "Closed" ? <span className="badge bg-danger">Closed</span>:''}</td>

    

          {/* <td>₹{item.paid_amount}</td> */}

      <td className="text-center d-flex justify-content-center align-items-center">
 <button
  className="btn btn-warning btn-sm rounded-circle d-flex align-items-center justify-content-center"
  style={{ width: "32px", height: "32px", padding: "0" }}
  onClick={() => {
    setSelectedCustomer(item);

    // Wait for state update to reflect in DOM
    setTimeout(() => {
      downloadPDF();
    }, 200); 
  }}
>
  <i className="fa fa-download"></i>
</button>

</td>

        </tr>
      ))
    )}
  </tbody>
    </table>

 <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">

  {/* LEFT SIDE */}
  <div className="d-flex align-items-center gap-2">
    <select
      className="form-select form-select-sm"
      style={{ width: "80px" }}
      value={recordsPerPage}
      onChange={(e) => setRecordsPerPage(Number(e.target.value))}
    >
      {pageSizes?.map((size) => (
    <option key={size} value={size}>
      {size}
    </option>
  ))}
    </select>

   <span className={lang === "ta" ? "fs-tamil" : ""}>
  {t("showing")} {(currentPage - 1) * recordsPerPage + 1} -{" "}
  {Math.min(currentPage * recordsPerPage, totalRecords)} {t("of")}{" "}
  {totalRecords}
</span>
  </div>

  {/* RIGHT SIDE */}
  <div>
    <CommonPagination
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
    />
  </div>

</div>

 </div>

      </div>




{/* Report pdf */}

<div
  className="modal fade"
  id="reportModal"
  tabIndex="-1"
  aria-hidden="true"
>
  <div className="modal-dialog modal-dialog-centered modal-lg print-modal-dialog">
    <div className="modal-content print-modal-content" ref={contentRef}>

      <div className="a4-page">

        {/* WATERMARK */}
        <div className="watermark">நண்பருள் அடகு கடை</div>

        {/* HEADER */}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <h2>நண்பருள் அடகு கடை - நிர்வாகம்</h2>
            <p>No.17/21 Main Road, Zion Nagar</p>
            <p>📞 +91 9790004209</p>
          </div>
          <img src={logo} style={{ width: "170px" ,height:'60px'}} />
        </div>

        <hr />

        {/* TITLE */}
        <h4>CUSTOMER LOAN REPORT</h4>

        {/* CUSTOMER BOX */}
        <div className="section-box customer-box">

          <h5>Customer Details</h5>

          <table>
            <tr>
              <td><b>Name</b></td>
              <td>{selectedCustomer?.name}</td>
              <td><b>Closed Date</b></td>
              <td>{selectedCustomer?.last_payment_date?.split(" ")[0] || "-"}</td>
            </tr>

            <tr>
              <td><b>Jewel</b></td>
              <td>{selectedCustomer?.jewel_name}</td>
              <td><b>Weight</b></td>
              <td>{selectedCustomer?.jewel_weight} g</td>
            </tr>
          </table>
        </div>

        {/* LOAN BOX */}
        <div className="section-box loan-box">

          <h5>Loan Summary</h5>

        <table>
  <tr>
    <td><b>Loan Amount</b></td>
    <td className="amount-blue">₹{selectedCustomer?.loan_amount}</td>

    <td><b>Interest</b></td>
    <td>{selectedCustomer?.intrest_rate}%</td>
  </tr>

  <tr>
    <td><b>Total Paid</b></td>
    <td className="amount-green">₹{selectedCustomer?.paid_amount}</td>

    <td><b>Balance</b></td>
    <td className="amount-red">₹{selectedCustomer?.balance}</td>
  </tr>

<tr className='mt-4'>
  <td colSpan="4" style={{ textAlign: "center", fontWeight: "bold" }}>
    Status:{" "}
    <span
      style={{
        color:
          selectedCustomer?.status === "Closed"
            ? "#198754"
            : selectedCustomer?.status === "Pending"
            ? "#ffc107"
            : "#0d6efd",
      }}
    >
      {selectedCustomer?.status || "Active"}
    </span>
  </td>
</tr>
</table>

        </div>

        {/* SIGNATURE */}
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "60px" }}>
          <div>
            <p>Customer Signature</p>
            <div style={{ borderTop: "1px solid #000", width: "180px" }}></div>
          </div>

          <div>
            <p>Authorized Signature</p>
            <div style={{ borderTop: "1px solid #000", width: "180px" }}></div>
          </div>
        </div>

        {/* FOOTER */}
        <p style={{ textAlign: "center", marginTop: "30px", fontSize: "12px" }}>
          This is a system generated report
        </p>

      </div>

    </div>
  </div>
</div>

    </div>
  )
}

export default Reports
